<div class="container-fluid content p-0">
  <div class="banner-item">

    <iframe #iframe id="frame1" style="width: 100%; height: 100vh;" load="access()" [src]="url"></iframe>  

  </div>
  </div>